import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { FormSectionCard } from 'components/_basic/FormSectionCard';

import { LiabilitiesAndEquityBody } from './components';
import { FullScreenWrapper } from '../../../components/FullScreenWrapper';
import { ProjectedBalanceFormHeader } from '../../components/ProjectedBalanceFormHeader';

const FormComponent = ({ disabled }: { disabled: boolean }) => {
  return (
    <>
      <ProjectedBalanceFormHeader disabled={disabled} />
      <LiabilitiesAndEquityBody disabled={disabled} />
    </>
  );
};

export const LiabilitiesAndEquity: FC = () => {
  const { t } = useTranslation();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.FINANCIAL_PLAN,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_FINANCIAL_PLAN.PROJECTED_BALANCE_SHEETS,
  );

  return (
    <>
      <FormSectionCard
        disabled={!canAccess}
        title={t('financialPlan.projectedBalanceSheets.liabilitiesAndEquity.title')}
        collapsible
      >
        <FullScreenWrapper title={t('financialPlan.projectedBalanceSheets.liabilitiesAndEquity.title')}>
          <FormComponent disabled={!canAccess} />
        </FullScreenWrapper>
      </FormSectionCard>
    </>
  );
};
